// @ts-nocheck — TODO: tipizzare (S6) — globalThis.bus tipizzato in types.d.ts
// ====== S2 partial: estrazione event-handlers Clienti ======
// I render functions restano in clienti.js (renderClienti, openClientModal).
// Qui spostiamo solo i listener globali e gli helper di binding che non hanno
// dipendenze dal closure interno di clienti.js (snapshot/dirty restano lì).
//
// Nota: questo file viene importato DOPO clienti.js, quindi può sicuramente
// usare le funzioni esposte su globalThis (renderClienti, openModal, ...).
// Per non duplicare logica esistente: ci limitiamo ad aggiungere wire-up
// nuovi (filtri server-side da pacchetto F7, mei-clienti filter, hook bus).

// Wire-up tabellare unificato per richiesta di re-render.
// Quando bus emette 'clienti:changed' o 'state:loaded', re-renderizza Clienti.
function wireBusListeners() {
  // @ts-ignore — bus globale
  if (!globalThis.bus) return;
  globalThis.bus.on('clienti:changed', () => {
    // @ts-ignore — renderClienti globale
    if (typeof renderClienti === 'function') renderClienti();
    // @ts-ignore
    if (typeof renderDashboard === 'function') renderDashboard();
  });
  globalThis.bus.on('accessi:changed', () => {
    // @ts-ignore
    if (typeof renderDashboard === 'function') renderDashboard();
    // @ts-ignore
    if (typeof renderAzioni === 'function') renderAzioni();
  });
  globalThis.bus.on('state:loaded', () => {
    // @ts-ignore
    if (typeof renderAll === 'function') renderAll();
  });
  globalThis.bus.on('scadenze:changed', () => {
    // @ts-ignore
    if (typeof renderDashboard === 'function') renderDashboard();
    // @ts-ignore
    if (typeof renderScadenze === 'function') renderScadenze();
  });
}

document.addEventListener('DOMContentLoaded', wireBusListeners);
// Comunque registra subito (al caricamento del modulo)
wireBusListeners();

export {};
